import { render, staticRenderFns } from "./passAdvantages.vue?vue&type=template&id=597afc38&scoped=true&"
import script from "./passAdvantages.vue?vue&type=script&lang=js&"
export * from "./passAdvantages.vue?vue&type=script&lang=js&"
import style0 from "./passAdvantages.vue?vue&type=style&index=0&id=597afc38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597afc38",
  null
  
)

export default component.exports